(function () {
  'use strict';

  var TAG_ID = '1488437317684174848';
  var DISPLAY_ORDER = ['年代', '利用シーン', '靴のサイズ', '着用感'];

  function labelReviewControls() {
    var root = document.getElementById('leeep-embedded-' + TAG_ID);
    if (!root) return;

    root.querySelectorAll('button.LeeepReviewScrollButtonL:not([aria-label])').forEach(function (button) {
      button.setAttribute('aria-label', '前のレビュー');
    });
    root.querySelectorAll('button.LeeepReviewScrollButtonR:not([aria-label])').forEach(function (button) {
      button.setAttribute('aria-label', '次のレビュー');
    });
  }

  function renderCustomProperties(reviews) {
    if (!Array.isArray(reviews)) return;

    var root = document.getElementById('leeep-embedded-' + TAG_ID);
    if (!root) return;

    reviews.forEach(function (review) {
      var card = root.querySelector('.LeeepReview[data-id="' + review.id + '"]');
      if (!card) return;

      var list = card.querySelector('.LeeepReviewCustomPropList');
      if (!list) return;

      list.querySelectorAll('[data-tabio-review-property]').forEach(function (item) {
        item.remove();
      });

      var properties = Array.isArray(review.review_custom_properties)
        ? review.review_custom_properties
        : [];

      DISPLAY_ORDER.forEach(function (keyName) {
        var property = properties.find(function (item) {
          return item.key_name === keyName && item.value;
        });
        if (!property) return;

        var row = document.createElement('div');
        row.className = 'c_leeep-review-property';
        row.setAttribute('data-tabio-review-property', '');

        var label = document.createElement('span');
        label.className = 'c_leeep-review-property__label';
        label.textContent = property.key_name;

        var value = document.createElement('span');
        value.className = 'c_leeep-review-property__value';
        value.textContent = property.value;

        row.appendChild(label);
        row.appendChild(value);
        list.appendChild(row);
      });

      var hasProperties = Boolean(list.querySelector('[data-tabio-review-property]'));
      list.classList.toggle('c_leeep-review-property-list--visible', hasProperties);
      card.classList.toggle('c_leeep-review--has-custom-properties', hasProperties);
    });

    labelReviewControls();
  }

  document.addEventListener('onLeeepContentsRendered', function (event) {
    if (!event.detail || String(event.detail.tag_id) !== TAG_ID) return;
    renderCustomProperties(event.detail.reviews);
  });
})();
